import React, { Component } from 'react'
import { Tooltip } from '@material-ui/core';

class TabCellTooltip extends Component {
    render() {

        const { item, chars } = this.props

        if (item.length > chars) {
            return (
                <Tooltip
                    title={item}
                    enterDelay={500}
                >
                    <div className="flex items-center">
                        {item}
                    </div>
                </Tooltip>
            )
        }

        return (
            <div className="flex items-center">
                {item}
            </div>
        )
    }
}

export default TabCellTooltip;


// WEBPACK FOOTER //
// src/main/components/TableCellTooltip.js